import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { parse } from 'query-string';

import { setHeaderFooterVisibility } from 'actions/headerfooter';
import { fetchReturnLabelInfo } from 'actions/account/returns';
import { Loader } from 'components/Loader';
import css from 'styles/containers/account/returnLabel.scss';

export class ReturnLabel extends Component {
  static contextTypes = {
    testId: PropTypes.func
  };

  static fetchDataOnServer(store) {
    return store.dispatch(setHeaderFooterVisibility(false));
  }

  componentDidMount() {
    const { fetchReturnLabelInfo, setHeaderFooterVisibility } = this.props;
    const { rmaId, contractId } = parse(window.location.search);
    fetchReturnLabelInfo({ rmaId, contractId });
    setHeaderFooterVisibility(false);
  }

  componentWillUnmount() {
    this.props.setHeaderFooterVisibility(true);
  }

  makeProducts() {
    const { returns: { labelInfo: { products, returnLabelProducts } } } = this.props;
    const { testId } = this.context;

    return (
      <>
      <hr />
      <h2>Items you are returning:</h2>
      <div className={css.products} data-test-id={testId('products')}>
        {products?.map(({ asin, brandName, productName }, i) => {
          const { imageUrl, color, size, width } = returnLabelProducts.find(p => p.asin === asin);

          return (
            <div className={css.product} key={i}>
              <img src={imageUrl} alt={`${brandName} ${productName}`} />
              <ul>
                <li>{brandName}</li>
                <li>{productName}</li>
                <li>{color && `Color: ${color}`}</li>
                <li>{size && `Size: ${size}`}</li>
                <li>{width && `Width: ${width}`}</li>
              </ul>
            </div>
          );
        })}
      </div>
      <hr />
      </>
    );
  }

  makeReturnLabel() {
    const {
      returns: {
        labelInfo: {
          orderId,
          rmaId,
          labelImageUrl
        }
      }
    } = this.props;
    const { testId } = this.context;

    return (
      <div className={css.container}>
        <button type="button" onClick={this.onPrintLabel} data-test-id={testId('printLabel')}>Print Label</button>
        <h1>UPS Electronic Return Label: View/Print Label</h1>
        <p>Your Return Confirmation ID:<span> {rmaId}</span></p>
        <p>Order #:<span> {orderId}</span></p>

        { this.makeProducts() }

        <ol className={css.instructions}>
          <li><em>Ensure that there are no other tracking labels attached to your package.</em></li>
          <li><em>Fold the printed label at the dotted line.</em> If you do not have a pouch, affix the folded label using clear plastic shipping tape over the entire label. Take care not to cover any seams or closures.</li>
          <li>
            <em>Collection and Drop-off.</em>
            <ul>
              <li>Take this package to any location of The UPS Store&reg;, UPS Customer Center, UPS Alliances, or Authorized Shipping Outlet near you. To find your closest UPS location visit <a href="https://www.ups.com/content/us/en/index.jsx">https://www.ups.com/content/us/en/index.jsx</a> and select Drop Off. <a href="https://www.ups.com/dropoff">Drop Off Locator</a></li>
              <li>Daily collection customers. Have your shipment(s) ready for the driver as usual.</li>
            </ul>
          </li>
        </ol>

        <p className={css.fold}>Fold Here</p>
        <hr />
        <img
          data-test-id={testId('labelImage')}
          className={css.upsLabel}
          src={labelImageUrl}
          alt="Return Label" />
      </div>
    );
  }

  makeQrCode() {
    const { returns: { labelInfo: { orderId, rmaId, qrcodeUrl } } } = this.props;
    const { testId } = this.context;

    return (
      <div className={css.container}>
        <h1>Your Return QR Code</h1>
        <img
          className={css.qrCode}
          data-test-id={testId('labelImage')}
          src={qrcodeUrl}
          alt="QR Code" />
        <p className={css.brightness}>Please turn your screen brightness up to allow for a good scan.</p>

        <hr />
        <p>Your Return Confirmation ID:<span> {rmaId}</span></p>
        <p>Order #:<span> {orderId}</span></p>

        { this.makeProducts() }

        <ol className={css.instructions}>
          <li>Place item(s) you’re returning back in their original packaging and put them in any cardboard box or a Zappos shipping box/bag.</li>
          <li>Remove any pre-existing labels or markings from the return shipping box/bag.</li>
          <li>Seal box/bag and take to an authorized UPS Store location. Find a UPS location.</li>
          <li>Show The UPS Store associate your QR code. They’ll scan it and print your FREE label.</li>
        </ol>
      </div>
    );
  }

  makeUspsLabel() {
    const {
      returns: {
        labelInfo: {
          orderId,
          rmaId,
          labelImageUrl,
          barcodeUrl
        }
      }
    } = this.props;
    const { testId } = this.context;

    return (
      <div className={css.container}>
        <button type="button" onClick={this.onPrintLabel} data-test-id={testId('printLabel')}>Print Label</button>
        <h1>Return Label: View/Print Label</h1>
        <p>Your Return Confirmation ID:<span> {rmaId}</span></p>
        <p>Order #:<span> {orderId}</span></p>

        { this.makeProducts() }

        <h2>Return Instructions</h2>
        <ol className={css.instructions}>
          <li>Cut out the <em>Merchandise Return Label</em> from the sheet (might be on next page).</li>
          <li><em>Include the barcode.</em></li>
          <li>Return address is <em>required</em> for proper handling.</li>
          <li>Affix the label securely to the parcel by gluing it over the old address label on the parcel or by taping down all four sides of the label onto the parcel.</li>
          <li>Cross out any other addresses on the outside of the parcel.</li>
          <li>You can drop it off at your nearest post office or hand it to your USPS mail carrier. Please do not use a UPS drop box.</li>
          <li>When using mailing acknowledgment or special services you must take the parcel to the post office.</li>
        </ol>
        <p>If you need to return your purchase please follow the easy returning instructions.</p>
        <p>Thank you for your purchase.</p>

        <div className={css.uspsLabelImgs}>
          <div className={css.uspsLabelWrap}>
            <img
              data-test-id={testId('labelImage')}
              src={labelImageUrl}
              alt="Return USPS Return Label" />
          </div>
          <div className={css.uspsBarcodeWrap}>
            <img
              src={barcodeUrl}
              alt="RMA Barcode" />
          </div>
        </div>
      </div>
    );
  }

  onPrintLabel = () => {
    window.print();
  }

  render() {
    const {
      returns: {
        labelInfo: { rmaId, qrcodeUrl, returnLabelPrepaid }
      }
    } = this.props;

    if (!rmaId) {
      return <Loader />;
    }
    return qrcodeUrl ? this.makeQrCode() :
      (returnLabelPrepaid ? this.makeReturnLabel() : this.makeUspsLabel());
  }
}

export const mapStateToProps = state => ({
  returns: state.returns
});

const mapDispatchToProps = {
  fetchReturnLabelInfo,
  setHeaderFooterVisibility
};

export default connect(mapStateToProps, mapDispatchToProps)(ReturnLabel);
